import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../hooks/useAdminAuth';

interface Props {
  children: React.ReactNode;
}

export function RequirePlatformAdmin({ children }: Props) {
  const { user, isPlatformAdmin, loading } = useAdminAuth();

  if (loading) {
    return <div style={{ padding: '2rem', fontFamily: 'monospace' }}>Loading...</div>;
  }

  if (!user || !isPlatformAdmin) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
